<form #f="ngForm">
	<div class="form-group row">
		<label class="col-lg-2 offset-lg-3 col-form-label">{{ 'FE.ORDER.FORMS.LABELS.TOREQUESTSALESSTATICLOCATION.ORDERTYPE' | localize }}</label>
		<div class="col-lg-4 kt-margin-b-10-tablet-and-mobile">
			<mat-select class="form-control"
						[(ngModel)]="selectedOrderType"
						name="orderType"
						(selectionChange)="onChangeOrderType()">
				<mat-option *ngFor="let orderOpt of orderTypes" [value]="orderOpt.id">{{orderOpt.name | localize}}</mat-option>
			</mat-select>
		</div>
	</div>
	<div class="form-group row">
		<label class="col-lg-2 offset-lg-3 col-form-label">{{ 'FE.ORDER.FORMS.LABELS.COMMON.CITY' | localize }}<i class="text-danger">*</i></label>
		<div class="col-lg-4 kt-margin-b-10-tablet-and-mobile">
			<mat-select class="form-control"
						placeholder="{{ 'FE.ORDER.FORMS.PLACEHOLDERS.COMMON.CITY' | localize }}"
						[(ngModel)]="selectedCity"
						name="city"
						#city="ngModel"
						(selectionChange)="onChangeCity()"
						required>
				<mat-option>
					{{ 'FE.ORDER.FORMS.COMBOBOX.COMMON.CHOOSE' | localize }}
				</mat-option>
				<mat-option *ngFor="let city of (cities | async)" [value]="city">{{city.cityName}}</mat-option>
			</mat-select>
			<!--<span *ngIf="showIsRequiredCityMessage" class="help-block" style="color: tomato;">Bu Alan Boş Bırakılamaz</span>-->
			<mat-error *ngIf="city.hasError('required')">{{ 'FE.REQUIREDFIELDS.COMMON.REQUIRED' | localize }}</mat-error>
		</div>
	</div>
	<div class="form-group row">
		<label class="col-lg-2 offset-lg-3 col-form-label">{{ 'FE.ORDER.FORMS.LABELS.TOREQUESTSALESSTATICLOCATION.DESTINATIONLOCATION' | localize }}<i class="text-danger">*</i></label>
		<div class="col-lg-4 kt-margin-b-10-tablet-and-mobile">

			<mat-select class="form-control"
						placeholder="{{ 'FE.ORDER.FORMS.PLACEHOLDERS.TOREQUESTSALESSTATICLOCATION.DESTINATIONLOCATION' | localize }}"
						[(ngModel)]="selectedAddressObj"
						name="address"
						#address="ngModel"
						(selectionChange)="onChangeLocation()"
						(click)="onClickLocation()"
						required>
				<mat-option>
					<ngx-mat-select-search [formControl]="addressSearchFilter"
										   placeholderLabel="{{ 'FE.ORDER.FORMS.PLACEHOLDERS.TOREQUESTSALESSTATICLOCATION.LOCATIONADDRESS' | localize }}"
										   noEntriesFoundLabel=""
										   ></ngx-mat-select-search>
				</mat-option>
				<mat-option *ngIf="isLocationNotFound">{{ 'FE.ORDER.FORMS.PLACEHOLDERS.TOREQUESTSALESSTATICLOCATION.LOCATIONADDRESS.NOTFOUND' | localize }}"</mat-option>

				<mat-option *ngIf="addressSearchFilter.value?.length < 3 && 0 < addressSearchFilter.value?.length">{{ 'FE.ORDER.FORMS.PLACEHOLDERS.COMMON.MINLETTER' | localize }}</mat-option>

				<mat-option *ngFor="let address of (locationObjListByCity | async)" [value]="address">
					{{address.name}}
				</mat-option>
			</mat-select>
			<!--<mat-error *ngIf="address.hasError('required')">{{ 'FE.REQUIREDFIELDS.COMMON.REQUIRED' | localize }}</mat-error>-->

			<div *ngIf="address.invalid && (address.dirty || address.touched)"
				 class="mat-error">
				<div *ngIf="address.errors.required">
					{{ 'FE.REQUIREDFIELDS.COMMON.REQUIRED' | localize }}
				</div>
				
			</div>



		</div>
	</div>


	<div class="form-group row" *ngIf="selectedAddressObj?.cityId">
		<label class="col-lg-2 offset-lg-3 col-form-label">{{ 'FE.ORDER.FORMS.LABELS.TOREQUESTSALESSTATICLOCATION.LOCATIONADDRESS' | localize }}</label>
		<div class="col-lg-4 kt-margin-b-10-tablet-and-mobile">
			<textarea class="form-control" rows="3" disabled>{{selectedAddressObj.fullAddress}}  {{selectedAddressObj.districtName}}</textarea>
		</div>
	</div>

	<div class="form-group row">
		<label class="col-lg-2 offset-lg-3 col-form-label">{{ 'FE.ORDER.FORMS.LABELS.TOREQUESTSALESSTATICLOCATION.RECEIVER' | localize }}
			<!-- <i class="text-danger">*</i> -->
		</label>
		<div class="col-lg-4 kt-margin-b-10-tablet-and-mobile">
			<div class="kt-input-icon kt-input-icon--left">
				<input class="form-control"
					   placeholder="{{ 'FE.ORDER.FORMS.PLACEHOLDERS.TOREQUESTSALESSTATICLOCATION.RECEIVER' | localize }}"
					   type="text"
					   [(ngModel)]="selectedNameSurname"
					   name="nameSurname"
					   #nameSurname="ngModel"
					   (change)="onChangeNameSurname()"
					   >
				<span class="kt-input-icon__icon kt-input-icon__icon--left">
					<span><i class="la la-user"></i></span>
				</span>
			</div>

			<!--<span *ngIf="showIsRequiredNameSurnameMessage" class="help-block" style="color: tomato;">Bu Alan Boş Bırakılamaz</span>-->
			<!--<mat-error *ngIf="nameSurname.hasError('required')">Bu Alan Boş Bırakılamaz</mat-error>-->
			<div *ngIf="nameSurname.invalid && (nameSurname.dirty || nameSurname.touched)"
				 class="mat-error">
				<div *ngIf="nameSurname.errors.required">
					{{ 'FE.REQUIREDFIELDS.COMMON.REQUIRED' | localize }}
				</div>
				
			</div>
		</div>
	</div>


	<div class="form-group row">
		<label class="col-lg-2 offset-lg-3 col-form-label">{{ 'FE.ORDER.FORMS.LABELS.TOREQUESTSALESSTATICLOCATION.RECEIVERPHONE' | localize }}
			<!-- <i class="text-danger">*</i> -->
		</label>
		<div class="col-lg-4 kt-margin-b-10-tablet-and-mobile">

			<input class="form-control"
				   #input
				   type="text"
				   maxlength="14"
				   placeholder="(5xx)-xxx-xxxx"
				   [(ngModel)]="selectedPhoneNumber"
				   name="phoneNumber"
				   #phoneNumber="ngModel"
				   (change)="onChangePhoneNumber()"
				   (keyup)="onKeyupPhoneMask()"
				   >
			<!--<mat-hint align="end">10 haneli başında sıfır olmadan giriniz. Örn. 5xxxxxxxxx</mat-hint>-->
			<!--<span *ngIf="showIsRequiredPhoneNumberMessage" class="help-block" style="color: tomato;">Bu Alan Boş Bırakılamaz</span>-->
			<!--<mat-error *ngIf="phoneNumber.hasError('required')">Bu Alan Boş Bırakılamaz</mat-error>-->
			<div *ngIf="phoneNumber.invalid && (phoneNumber.dirty || phoneNumber.touched)"
				 class="mat-error">
				<div *ngIf="phoneNumber.errors.required">
					{{ 'FE.REQUIREDFIELDS.COMMON.REQUIRED' | localize }}
				</div>
			</div>
		</div>
	</div>

</form>
